(function(){
  'use strict';
  if(window.__dxbr)return;window.__dxbr=1;
  var RM=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function all(q,r){return Array.prototype.slice.call((r||document).querySelectorAll(q));}
  function cl(v,a,b){return Math.max(a,Math.min(b,v));}
  function ready(f){if(document.readyState!=='loading')f();else document.addEventListener('DOMContentLoaded',f);}

  function hdBottom(){
    var b=0,els=document.elementsFromPoint?document.elementsFromPoint(window.innerWidth/2,2):[];
    for(var i=0;i<els.length;i++){
      var p=els[i];if(p.closest('[data-dxbc]'))continue;
      while(p&&p!==document.body&&p!==document.documentElement){
        var ps=getComputedStyle(p).position;
        if(ps==='sticky'||ps==='fixed'){var r=p.getBoundingClientRect();if(r.top<=2&&r.height<320&&r.bottom>b)b=r.bottom;break;}
        p=p.parentElement;
      }
    }
    return Math.max(0,Math.round(b));
  }

  function split(el){
    (function walk(node){
      Array.prototype.slice.call(node.childNodes).forEach(function(c){
        if(c.nodeType===3){
          var parts=c.textContent.split(' '),f=document.createDocumentFragment();
          parts.forEach(function(t,i){
            if(t){var s=document.createElement('span');s.className='w';s.textContent=t;f.appendChild(s);}
            if(i<parts.length-1)f.appendChild(document.createTextNode(' '));
          });
          node.replaceChild(f,c);
        }else if(c.nodeType===1)walk(c);
      });
    })(el);
    return all('.w',el);
  }

  function count(e){
    var to=parseFloat(e.getAttribute('data-to')),dec=parseInt(e.getAttribute('data-dec'),10)||0;
    if(RM||!to)return;
    var t0=null;
    function f(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/1600),v=to*(1-Math.pow(1-k,3));e.textContent=v.toFixed(dec).replace('.',',');if(k<1)requestAnimationFrame(f);}
    requestAnimationFrame(f);
  }

  ready(function(){
    all('[data-dxbr-hero]').forEach(function(h){
      var b=h.querySelector('[data-dxbr-sw]'),l=b&&b.querySelector('b'),on=false,touched=false;
      function set(v){
        on=v;
        if(v&&!RM){h.classList.remove('is-flick');void h.offsetWidth;h.classList.add('is-flick');setTimeout(function(){h.classList.remove('is-flick');},1300);}
        h.classList.toggle('is-on',v);
        if(b){b.setAttribute('aria-pressed',v?'true':'false');if(l)l.textContent=l.getAttribute(v?'data-on':'data-off');}
      }
      if(b)b.addEventListener('click',function(){touched=true;set(!on);});
      setTimeout(function(){if(!touched)set(true);},RM?0:900);
    });

    var W=all('[data-dxbr-words]').map(function(el){return {el:el,w:split(el),n:-1};});

    var nav=document.querySelector('[data-dxbc-nav]'),chs=all('[data-dxbc-ch]'),links=all('[data-dxbc-link]'),bar=document.querySelector('[data-dxbc-bar]'),ol=nav&&nav.querySelector('ol'),act=null,top=0;

    function setAct(id){
      if(id===act)return;act=id;var cur=null;
      links.forEach(function(a){var m=a.getAttribute('href')==='#'+id;a.classList.toggle('is-on',m);if(m){a.setAttribute('aria-current','true');cur=a;}else a.removeAttribute('aria-current');});
      if(cur&&ol&&ol.scrollWidth>ol.clientWidth+4){var x=cur.getBoundingClientRect().left-ol.getBoundingClientRect().left+ol.scrollLeft-24;ol.scrollTo({left:Math.max(0,x),behavior:RM?'auto':'smooth'});}
    }

    var tick=false;
    function frame(){
      tick=false;
      var vh=window.innerHeight;
      W.forEach(function(o){
        var r=o.el.getBoundingClientRect(),p=RM?1:cl((vh*.88-r.top)/(r.height+vh*.38),0,1),n=Math.round(p*o.w.length);
        if(n===o.n)return;o.n=n;
        o.w.forEach(function(s,i){s.classList.toggle('is-lit',i<n);});
      });
      if(nav&&chs.length){
        var t=hdBottom();
        if(t!==top){top=t;nav.style.setProperty('--dxbr-top',t+'px');}
        var nb=top+nav.offsetHeight,f=chs[0].getBoundingClientRect(),lr=chs[chs.length-1].getBoundingClientRect();
        var den=lr.bottom-f.top-(vh-nb);
        if(bar)bar.parentNode.style.setProperty('--p',den>0?cl((nb-f.top)/den,0,1).toFixed(4):0);
        var id=null;
        chs.forEach(function(c){if(c.getBoundingClientRect().top<=nb+vh*.35)id=c.id;});
        setAct(id||chs[0].id);
      }
    }
    function req(){if(!tick){tick=true;requestAnimationFrame(frame);}}
    window.addEventListener('scroll',req,{passive:true});
    window.addEventListener('resize',req);
    frame();

    function go(id,e){
      var el=document.getElementById(id);if(!el)return;
      if(e)e.preventDefault();
      var off=hdBottom()+(el.hasAttribute('data-dxbc-ch')&&nav?nav.offsetHeight:0)+(el.hasAttribute('data-dxbc-ch')?0:8);
      window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-off+1,behavior:RM?'auto':'smooth'});
      if(history.replaceState)history.replaceState(null,'','#'+id);
    }
    document.addEventListener('click',function(e){
      var a=e.target.closest('.dxbr a[href^="#"],.dxbc a[href^="#"]');if(!a)return;
      var id=a.getAttribute('href').slice(1);if(id)go(id,e);
    });

    var lit=all('[data-lit]'),cnt=all('.dxbr [data-to]'),rv=all('.dxbr .dx-rv,.dxbc .dx-rv,.dxbf .dx-rv');
    if(RM||!('IntersectionObserver' in window)){
      lit.forEach(function(e){e.classList.add('is-lit');});
      rv.forEach(function(e){e.classList.add('is-in');});
      return;
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('is-lit');io.unobserve(e.target);});},{threshold:.3});
    lit.forEach(function(e){io.observe(e);});
    var ic=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;count(e.target);ic.unobserve(e.target);});},{threshold:.6});
    cnt.forEach(function(e){ic.observe(e);});
    var ir=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('is-in');ir.unobserve(e.target);});},{threshold:.15});
    setTimeout(function(){rv.forEach(function(e){if(!e.classList.contains('is-in'))ir.observe(e);});},400);
  });
})();